/* "Häufig zusammen gekauft" unter dem Warenkorb-Button (snippets/ss-pdp-upsell.liquid)
   - Gold/Silber folgt der gewählten Farbe der Hauptkette (Options-App BCPO oder Theme-Auswahl)
   - Tipp auf eine Zeile legt das Produkt sofort in den Warenkorb, erneuter Tipp nimmt es wieder heraus
   - Personalisierte Armbänder/Ketten bekommen den Wunschnamen, der oben beim Hauptprodukt eingetragen ist
   - Danach wird der Warenkorb über das Event "ss:cart-updated" aktualisiert (assets/custom-cart-drawer.js) */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var MSG_NAME = 'Bitte gib oben zuerst deinen Wunschnamen ein – das Schmuckstück wird mit demselben Namen gefertigt.';
  var MSG_ERROR = 'Das hat leider nicht geklappt. Bitte versuche es noch einmal.';

  function post(url, body) {
    return fetch(ROOT + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || MSG_ERROR);
        return j;
      });
    });
  }

  function cartChanged() {
    document.dispatchEvent(new CustomEvent('ss:cart-updated'));
  }

  function init(box) {
    if (box.getAttribute('data-ready')) return;
    box.setAttribute('data-ready', '1');
    if (box.closest('quick-add-modal, .quick-add-modal')) { box.remove(); return; }

    var scope = box.closest('section') || document;
    var items = Array.prototype.slice.call(box.querySelectorAll('[data-ss-fbt-item]'));
    var note = box.querySelector('[data-ss-fbt-note]');
    var variants = {};
    try { variants = JSON.parse(box.querySelector('[data-ss-fbt-variants]').textContent); } catch (e) {}
    var color = null;
    var noteTimer = null;

    function nameInput() { return scope.querySelector('input[name="properties[Wunschname]"]'); }

    function currentColor() {
      var vals = [];
      var picked = scope.querySelector('.bcpo-front-color-option:checked');
      if (picked) vals.push(picked.value);
      Array.prototype.forEach.call(scope.querySelectorAll('variant-radios input:checked, variant-selects select'), function (i) {
        vals.push(i.value);
      });
      var idInput = scope.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
      if (idInput && variants[idInput.value]) vals = vals.concat(variants[idInput.value]);
      for (var i = 0; i < vals.length; i++) {
        if (/silber|silver/i.test(vals[i])) return 'silber';
        if (/gold/i.test(vals[i])) return 'gold';
      }
      return 'gold';
    }

    function paint(item, c) {
      var d = item.dataset;
      d.variant = d[c + 'Id'];
      var img = item.querySelector('img');
      if (img && d[c + 'Img']) img.src = d[c + 'Img'];
      item.querySelector('[data-price]').textContent = '+' + d[c + 'Price'];
      var cmp = item.querySelector('[data-compare]');
      cmp.textContent = d[c + 'Compare'] || '';
      cmp.hidden = !d[c + 'Compare'];
      var label = item.querySelector('[data-color]');
      if (label) label.textContent = c === 'silber' ? 'Silber' : 'Gold';
    }

    function showNote(msg) {
      note.textContent = msg;
      note.hidden = false;
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () { note.hidden = true; }, 6000);
    }

    function setChecked(item, line) {
      var on = !!line;
      item.classList.toggle('is-checked', on);
      item.setAttribute('aria-checked', on ? 'true' : 'false');
      if (on) {
        item.dataset.key = line.key;
        item.dataset.qty = line.quantity;
      } else {
        delete item.dataset.key;
        delete item.dataset.qty;
      }
    }

    function add(item) {
      var props = {};
      if (item.dataset.personal === 'true') {
        var input = nameInput();
        var name = input ? input.value.trim() : '';
        if (!name) {
          showNote(MSG_NAME);
          if (input) {
            input.scrollIntoView({ block: 'center', behavior: 'smooth' });
            input.focus({ preventScroll: true });
          }
          return Promise.resolve(false);
        }
        props.Wunschname = name;
      }
      return post('cart/add.js', { items: [{ id: Number(item.dataset.variant), quantity: 1, properties: props }] })
        .then(function (j) {
          setChecked(item, j.items && j.items[0]);
          var meta = item.querySelector('[data-name-meta]');
          if (meta && props.Wunschname) meta.textContent = 'Name: ' + props.Wunschname;
          return true;
        });
    }

    function remove(item) {
      var qty = Math.max(0, (parseInt(item.dataset.qty, 10) || 1) - 1);
      return post('cart/change.js', { id: item.dataset.key, quantity: qty }).then(function () {
        setChecked(item, null);
        var meta = item.querySelector('[data-name-meta]');
        if (meta) meta.textContent = 'mit deinem Wunschnamen';
        return true;
      });
    }

    function run(item, task) {
      if (item.classList.contains('is-busy')) return;
      item.classList.add('is-busy');
      note.hidden = true;
      task()
        .then(function (changed) { if (changed) cartChanged(); })
        .catch(function (err) { showNote((err && err.message) || MSG_ERROR); })
        .then(function () { item.classList.remove('is-busy'); });
    }

    function toggle(item) {
      run(item, function () { return item.dataset.key ? remove(item) : add(item); });
    }

    // Farbe der Kette gewechselt: Anzeige umstellen, bereits hinzugefügte Teile im Warenkorb mittauschen
    function sync() {
      var c = currentColor();
      if (c === color) return;
      color = c;
      items.forEach(function (item) {
        var before = item.dataset.variant;
        paint(item, c);
        if (item.dataset.key && item.dataset.single !== 'true' && before !== item.dataset.variant) {
          run(item, function () { return remove(item).then(function () { return add(item); }); });
        }
      });
    }

    box.addEventListener('click', function (e) {
      if (e.target.closest('a')) return;
      var item = e.target.closest('[data-ss-fbt-item]');
      if (item) toggle(item);
    });
    box.addEventListener('keydown', function (e) {
      var item = e.target.closest && e.target.closest('[data-ss-fbt-item]');
      if (!item || e.target.closest('a')) return;
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggle(item);
      }
    });
    scope.addEventListener('change', function () { setTimeout(sync, 30); });
    scope.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.bcpo-color-parent, variant-radios')) setTimeout(sync, 60);
    });

    sync();
    // Die Options-App baut ihre Farbauswahl erst nach dem Laden auf
    var tries = 0;
    var timer = setInterval(function () {
      sync();
      if (++tries >= 20) clearInterval(timer);
    }, 250);
  }

  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ss-fbt]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
